<template>
  <div class="detailBox">
    <ul class="detailContent">
      <el-form
        :model="state.model"
        label-width="120px"
        :scroll-to-error="true"
        ref="formDom"
        inline
        style="position: relative"
      >
        <el-form-item
          label="状态"
          prop="IsQy"
          :rules="[
            { required: true, message: '请选择角色状态', trigger: 'blur' },
          ]"
        >
          <el-switch
            v-model="state.model.IsQy"
            inline-prompt
            active-text="可售"
            inactive-text="停用"
          />
        </el-form-item>
        <el-form-item
          label="供应商"
          prop="GysId"
          :rules="[
            { required: true, message: '请选择供应商', trigger: 'blur' },
          ]"
          style="flex: 1; margin-right: 0"
        >
          <el-select
            v-model="state.model.GysId"
            placeholder="--请选择供应商--"
            value-key="Mc"
            :disabled="!Array.isArray(state.gysData)"
          >
            <el-option
              v-for="item in state.gysData"
              :key="item.Id"
              :label="item.Mc"
              :value="item.Id"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          label="门票名称"
          prop="Mc"
          :rules="[
            { required: true, message: '请输入门票名称', trigger: 'blur' },
          ]"
          style="width: 100%"
        >
          <el-input v-model="state.model.Mc" />
        </el-form-item>
        <el-form-item
          label="景点类型"
          prop="Jdlx"
          :rules="[
            { required: true, message: '请选择景点类型', trigger: 'blur' },
          ]"
          style="width: 30%"
        >
          <el-select v-model="state.model.Jdlx" placeholder="--请选择景点类型--">
            <el-option label="主题乐园" value="主题乐园" />
            <el-option label="自然景区" value="自然景区" />
            <el-option label="历史古迹" value="历史古迹" />
            <el-option label="博物馆" value="博物馆" />
            <el-option label="动物园" value="动物园" />
            <el-option label="植物园" value="植物园" />
            <el-option label="游乐场" value="游乐场" />
            <el-option label="其他" value="其他" />
          </el-select>
        </el-form-item>
        <el-form-item
          label="联系电话"
          prop="Dh"
          :rules="[
            { required: true, message: '请输入联系电话', trigger: 'blur' },
          ]"
          style="width: 30%; margin-right: 0"
        >
          <el-input v-model="state.model.Dh" />
        </el-form-item>
        <el-form-item
          label="限购数量"
          prop="Xgsl"
          style="width: 30%; margin-right: 0"
        >
          <el-input-number v-model="state.model.Xgsl" :min="0" controls-position="right" style="width: 100%" placeholder="0表示不限" />
        </el-form-item>
        <el-form-item label="地址" style="width: 100%">
          <el-input v-model="state.model.Dz" />
        </el-form-item>
        <el-form-item
          label="经度"
          prop="Jd"
          style="width: 30%"
        >
          <el-input v-model="state.model.Jd" placeholder="例如: 116.404" />
        </el-form-item>
        <el-form-item
          label="纬度"
          prop="Wd"
          style="width: 30%; margin-right: 0"
        >
          <el-input v-model="state.model.Wd" placeholder="例如: 39.915" />
        </el-form-item>
        <el-form-item style="width: 30%; margin-right: 0">
          <el-button type="text" @click="openMapModal()" style="padding: 0; color: #007bff">
            🗺️ 坐标拾取
          </el-button>
        </el-form-item>
        <el-form-item
          label="开放时间"
          prop="Kfsj"
          style="width: 30%; margin-right: 0"
        >
          <el-input v-model="state.model.Kfsj" placeholder="例如: 08:00-18:00" />
        </el-form-item>
        <el-form-item label="验证方式" style="width: 100%">
          <el-radio-group v-model="state.model.Yzfs">
            <el-radio label="身份证">身份证</el-radio>
            <el-radio label="核销码">核销码</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="年龄段" style="width: 100%">
          <el-checkbox-group v-model="state.model.Ndzcl">
            <el-checkbox label="成人" />
            <el-checkbox label="儿童" />
            <el-checkbox label="老人" />
            <el-checkbox label="学生" />
            <el-checkbox label="军人" />
            <el-checkbox label="残疾人" />
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="免票政策" style="width: 100%">
          <el-input
            type="textarea"
            v-model="state.model.Mpzc"
            :autosize="{ minRows: 2 }"
            placeholder="例如：1.2米以下儿童免票、70岁以上老人免票等"
          />
        </el-form-item>
        <el-form-item label="门票简介" style="width: 100%">
          <el-input
            type="textarea"
            v-model="state.model.Jj"
            :autosize="{ minRows: 2 }"
          />
        </el-form-item>
        <el-form-item label="购票须知" style="width: 100%">
          <el-input
            type="textarea"
            v-model="state.model.Gmxz"
            :autosize="{ minRows: 2 }"
          />
        </el-form-item>

        <el-form-item label="是否预约" prop="IsYuyue" style="width: 30%">
          <el-switch
            v-model="state.model.IsYuyue"
            inline-prompt
            active-text="需要"
            inactive-text="不需要"
          />
        </el-form-item>
        <el-form-item
          v-if="state.model.IsYuyue"
          label="提前天数"
          prop="YuyueTianShu"
          style="width: 30%; margin-right: 0"
        >
          <el-input-number
            v-model="state.model.YuyueTianShu"
            :min="1"
            controls-position="right"
            style="width: 100%"
            placeholder="请指定天数"
          />
        </el-form-item>

        <el-form-item
          label="核销码类型"
          prop="HeXiaoMaLeiXing"
          style="width: 30%; margin-right: 0"
        >
          <el-select
            v-model="state.model.HeXiaoMaLeiXing"
            placeholder="请选择"
          >
            <el-option label="系统自动码" :value="1" />
            <el-option label="OTA码" :value="2" />
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="state.model.HeXiaoMaLeiXing === 2"
          label="OTA商品码"
          prop="SupplierGoodsId"
          style="width: 30%; margin-right: 0"
        >
          <el-input v-model="state.model.SupplierGoodsId" placeholder="请输入OTA商品码" />
        </el-form-item>
      </el-form>
    </ul>
    <ul class="detailBtn">
      <el-button type="primary" @click="onSubmit()">提交</el-button>
    </ul>
  </div>
</template>

<script>
import { getCurrentInstance, onMounted, onUnmounted, reactive, ref } from "vue";
import {
  menpiao_add,
  menpiao_edit,
  menpiao_detail,
  gongyingshang_select,
} from "@/http/api";

export default {
  props: {
    id: Number,
  },
  setup(props, { emit }) {
    const { proxy } = getCurrentInstance();
    const formDom = ref(null);
    const state = reactive({
      model: {
        IsQy: true,
        Ndzcl: [],
        Jdlx: "",
        Yzfs: "二维码",
        Xgsl: 0,
        Tps: [],
        HeXiaoMaLeiXing: 1,
        SupplierGoodsId: "",
      },
    });
    onMounted(() => {
      loadGys();

      if (props.id) {
        menpiao_detail(props.id).then((res) => {
          if (res.status == 200) {
            state.model = res.data;
            if (typeof state.model.Ndzcl === 'string') {
              state.model.Ndzcl = state.model.Ndzcl.split(',');
            }
            if (state.model.HeXiaoMaLeiXing === null || state.model.HeXiaoMaLeiXing === undefined || state.model.HeXiaoMaLeiXing === '') {
              state.model.HeXiaoMaLeiXing = 1;
            }
          }
        });
      }
    });

    onUnmounted(() => {
      delete window.handleMapSelect;
      delete window.closeMapModal;
      if (window.mapModal) {
        window.mapModal.close();
        window.mapModal = null;
      }
    });

    //加载供应商下拉数据
    const loadGys = () => {
      gongyingshang_select().then((res) => {
        if (res.status == 200) state.gysData = res.data;
      });
    };

    const onSubmit = () => {
      formDom.value.validate((valid) => {
        if (!valid) return false;

        const submitData = { ...state.model };
        if (Array.isArray(submitData.Ndzcl)) {
          submitData.Ndzcl = submitData.Ndzcl.join(',');
        }

        if (props.id) {
          menpiao_edit(submitData).then((res) => {
            proxy.$post_response(res, emit);
          });
        } else {
          menpiao_add(submitData).then((res) => {
            proxy.$post_response(res, emit);
          });
        }
      });
    };

    const openMapModal = () => {
      const lng = state.model.Jd || 117.251091;
      const lat = state.model.Wd || 31.517890;
      const url = `/map_picker.html?lng=${lng}&lat=${lat}`;
      
      const modalWidth = 850;
      const modalHeight = 680;
      const left = (window.screen.width - modalWidth) / 2;
      const top = (window.screen.height - modalHeight) / 2;
      
      window.mapModal = window.open(
        url,
        '_blank',
        `width=${modalWidth},height=${modalHeight},left=${left},top=${top},toolbar=no,scrollbars=no,resizable=yes`
      );
      
      window.handleMapSelect = (data) => {
        state.model.Jd = data.lng;
        state.model.Wd = data.lat;
        if (data.address) {
          state.model.Dz = data.address;
        }
        if (window.mapModal) {
          window.mapModal.close();
          window.mapModal = null;
        }
      };
      
      window.closeMapModal = () => {
        if (window.mapModal) {
          window.mapModal.close();
          window.mapModal = null;
        }
      };
    };

    return {
      state,
      formDom,
      onSubmit,
      openMapModal,
    };
  },
};
</script>
<style scoped>
</style>